import { Avatar, Box, Chip, Link as MuiLink, Typography } from '@mui/material';
import Link from 'next/link';
import { digitSeperator } from '@/utils/digitSeperator';
import Image from 'next/image';

const CourseCard = ({ course, courseType }) => {
  const description = course.description
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ');

  return (
    <Box
      sx={{
        height: '400px',
        width: '300px',
        bgcolor: 'background.paper',
        borderRadius: 1,
        overflow: 'hidden',
        boxShadow: 6,
      }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateRows: 'auto 1fr',
          height: '100%',
        }}>
        <MuiLink
          href={
            courseType === 'public-course'
              ? `/course/${course.shortId}/${course.slugId}`
              : course.isActive
                ? `/course/${course.shortId}/${course.slugId}`
                : `/panel/create-course?id=${course._id}&sidebar=off`
          }
          component={Link}
          variant="baseLink">
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              height: '195px',
            }}>
            <Image
              src={course.cover}
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 100vw"
              alt={course.title}
              style={{ objectFit: 'cover' }}
            />
          </Box>
        </MuiLink>
        <Box
          sx={{
            display: 'grid',
            gridTemplateRows: 'auto 1fr auto',
            px: 1,
            pb: 1,
            gap: 2,
          }}>
          <MuiLink
            component={Link}
            href={`/profile/${course.author?.username}`}
            variant="baseLink">
            <Box
              sx={{
                display: 'flex',
                gap: 0.5,
                alignItems: 'center',
              }}>
              <Box sx={{ position: 'relative', width: '65px', height: '40px' }}>
                <Avatar
                  alt={course.author.fullName}
                  src={course?.author?.avatar}
                  sx={{
                    width: 64,
                    height: 64,
                    position: 'absolute',
                    top: -20,
                  }}
                />
              </Box>
              <Box>
                <Typography variant="body2">
                  {course?.author?.fullName}
                </Typography>
              </Box>
            </Box>
          </MuiLink>
          <MuiLink
            component={Link}
            href={
              courseType === 'public-course'
                ? `/course/${course.shortId}/${course.slugId}`
                : course.isActive
                  ? `/course/${course.shortId}/${course.slugId}`
                  : `/panel/create-course?id=${course._id}&sidebar=off`
            }
            variant="baseLink">
            <Box sx={{ px: 1 }}>
              <Typography className="truncate-1" fontWeight={500}>
                {course.title}
              </Typography>
              <Typography
                // dangerouslySetInnerHTML={{
                //   __html: course.description,
                // }}
                color="text.secondary"
                variant="body2"
                className="truncate-3"
                textAlign="justify"
                lineHeight={1.75}>
                {description}
              </Typography>
            </Box>
          </MuiLink>
          <Box
            display="flex"
            justifyContent={`${courseType === 'teacher-course' ? 'space-between' : 'flex-end'} `}>
            {courseType === 'teacher-course' && (
              <Chip
                size="small"
                label={
                  course.isDeleted
                    ? 'حذف شده'
                    : course.isActive
                      ? 'منتشر شده'
                      : 'پیش‌نویس'
                }
                variant="outlined"
                color={
                  course.isDeleted
                    ? 'error'
                    : course.isActive
                      ? 'success'
                      : 'info'
                }
              />
            )}

            <Typography variant="caption" px={1}>
              هزینه:{' '}
              {course.price
                ? `${digitSeperator(course.price)} تومان`
                : 'رایگان'}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CourseCard;
